import { getBackVersion } from '../config';
import { SessionSnapshot } from '../models';
import api from './api';

const getAccountSessions = () =>
    api.request<SessionSnapshot[]>({
        method: 'GET',
        url: `${getBackVersion()}/account/sessions`,
    });

const invalidateSession = (id: string) =>
    api.request<boolean>({
        method: 'DELETE',
        url: `${getBackVersion()}/account/sessions/` + id,
    });

export default {
    getAccountSessions,
    invalidateSession,
};
